<template>
  <div id="case">
    <div class="case-content">
      <div class="content-title">客户成功案例</div>
      <img src="../../../assets/images/sem-pro/H5/success_exam/success_exam.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: Array,
  },
}
</script>

<style lang="less" scoped>
@base-scale: calc((100vw / 375));
.basisDisplay(@justify,@align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}
.columnDisplay(@justify,@align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
.case-content {
  background-color: #fff;
  padding-bottom: calc(@base-scale*38.52);
  padding-top: calc(@base-scale*38);
  overflow: hidden;
  .content-title {
    -webkit-text-size-adjust: none;
    width: calc(@base-scale*234);
    height: calc(@base-scale*22);
    font-size: calc(@base-scale*16);
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    text-align: center;
    margin: 0 auto calc(@base-scale*22);
  }
  img {
    height: calc(@base-scale*163);
  }
}
</style>
